<div class="absolute inset-0 bg-white z-1004">
  <DetailSensor :sensorId="sensorId" :renderInPopup="true"/>
</div>
